@if (hasAny()) {
  <div class="membership-chips">
    @for (item of visible(); track $index) {
      <span
        class="membership-chip"
        [class.membership-chip--primary]="!differentiatePrimary() || item.isPrimary"
        [class.membership-chip--secondary]="differentiatePrimary() && !item.isPrimary"
        [matTooltip]="item.truncated ? item.full : ''"
        matTooltipClass="app-tooltip"
        matTooltipPosition="above"
        >{{ item.display }}</span
      >
    }
    @if (hiddenCount() > 0) {
      <span
        class="membership-chip membership-chip--more"
        [matTooltip]="tooltipText()"
        matTooltipClass="app-tooltip"
        matTooltipPosition="above"
        >+{{ hiddenCount() }}</span
      >
    }
  </div>
}
